import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { validFile } from '../../utils/validators';
import galary from '../../assets/images/element/gallery.svg'
import PhoneInput from 'react-phone-number-input';
import { useState } from 'react';
import 'react-phone-number-input/style.css'
import { selectUserRequestsData } from '../../redux/apiSlices/requestSlice';
import Alert from '../../components/Alert/Alert';
import { useOrgVerifyRequestMutation } from '../../redux/apiSlices/organizationSlice';
import AddAttachmentModal from './AddAttachmentModal';


function OrganizationVerifyAccount() {
  const { user } = useSelector(state => state.userState)

  const {verification_status} = useSelector(selectUserRequestsData)

  console.log(verification_status)

  const navigate = useNavigate();


  const [orgVerifyRequest, {isLoading}  ] = useOrgVerifyRequestMutation();

  const [repName, setRepName] = useState('');
  const [place, setPlace] = useState('');
  const [idNumber, setIdNumber] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [oldImage, setOldImage] = useState(null);
  const [idPhoto, setIdPhoto] = useState(null);
  const [idPhotoErrorMsg, setIdPhotoErrorMsg] = useState('');

  const [showAttachModal, setShowAttachModal] = useState(false)
  const [attachments, setAttachments] = useState([]);


  const idNumberHandler = (event) => {
    setIdNumber(event.target.value);
  }

  const handleShowAttachModal = () => {

    setShowAttachModal(true)
  }

  const handleAddAttchment = (attch) => {
    console.log(attch)
    setAttachments(prev => [...prev, attch ]);
    

  };

  

  

  const idPhotoHandler = (e) => {
    if (e.target.files[0]) {
      if (validFile(e.target.files[0]?.name)) {
        console.log('valid file')
        let imageUrl = URL.createObjectURL(e.target.files[0]);
        if (idPhotoErrorMsg) {
            setIdPhotoErrorMsg('')
        }
        setIdPhoto({
          image: e.target.files[0],
          imageUrl,
        });
        } else {
          setIdPhotoErrorMsg('not soportet file extention');
          setIdPhoto(null)
        }
      }
    };

  const handleRemoveIdPhoto = () => {
    setIdPhoto(null)
  }

  const phoneNumberHandler = (number) => {
    setPhoneNumber(number);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!idPhotoErrorMsg){
      let formData = new FormData();
      formData.append('representative_name', repName);
      formData.append('representative_id_num', idNumber);
      formData.append('phone_number', phoneNumber);
      formData.append('place', place);
      if(idPhoto) {
        formData.append('representative_id_copy', idPhoto.image);
      }
      for (let i = 0; i < attachments?.length; i++) {
        let title = attachments[i].title ? attachments[i].title : attachments[i].file.name
        formData.append("attachments", attachments[i].file, title)
        console.log('index', i)
      }
      try {
        await orgVerifyRequest(formData).unwrap()
        navigate('/successful-page/generl')

      } catch (err) {
          console.error('Failed to save the changes', err)
      }
   }

  };
  return (
    <>
    <AddAttachmentModal
      showModal={showAttachModal}
      handleCloseModal={()=> setShowAttachModal(false)}
      handleAddAttchment={handleAddAttchment}
      />
    <div class="col-xl-9">
      <div class="card bg-transparent border rounded-3">
          {/* <!-- Card header --> */}
          <div class="card-header bg-transparent border-bottom">
            <h3 class="card-header-title mb-0">طلب توثيق الحساب</h3>
          </div>
          {/* <!-- Card body START --> */}
          <div class="card-body">
          {/* <!-- Form --> */}
          {verification_status === 'verified' ? 
          <Alert type='info' text='حسابك موثق مسبقا بامكانك تقديم عريضة'/>
          : verification_status === 'pending' ? 
          <Alert type='success' text='حسابك قيد المراجعة سيتم توثيقه قربيا'/>
          :
            <form class="row g-4">


              {/* <!-- Profile picture --> */}
              <div class="col-12 justify-content-center align-items-center">
                <label class="form-label">صورة هوية ممثل المؤسسة</label>
                <div class="d-flex align-items-center">
                    <label class="position-relative me-4" for="uploadfile-1" title="Replace this pic">
                    {/* <!-- idPhoto place holder --> */}
                    <span class="avatar avatar-xl">
                        <img id="uploadfile-1-preview" class="avatar-img  border border-white border-3 shadow" src={idPhoto?.imageUrl ? idPhoto.imageUrl : oldImage ? oldImage :galary} alt=""/>
                    </span>
                    {/* <!-- Remove btn --> */}
                    {/* {avatar?.imageUrl || oldImage ? <button onClick={handleRemoveIdPhoto} type="button" class="uploadremove"><i class="bi bi-x text-white"></i></button> : null} */}
                    <button onClick={handleRemoveIdPhoto} type="button" class="uploadremove"><i class="bi bi-x text-white"></i></button>
                    </label>
                    {/* <!-- Upload button --> */}
                    <label class="btn btn-primary-soft mb-0" for="uploadfile-1">اختيار الصورة</label>
                    <input 
                    id="uploadfile-1" 
                    class="form-control d-none" 
                    type="file"
                    onChange={idPhotoHandler}
                    />
                </div>
                </div>

               {/* <!-- place --> */}
               <div class="col-lg-6">
                <label class="form-label">مكان المؤسسة</label>
                    <input 
                    type="text" 
                    class="form-control" 
                    value={place} 
                    onChange={(e) => setPlace(e.target.value)}
                    placeholder="مكان المؤسسة"
                    />
                    </div>
               {/* <!-- Full name --> */}
               <div class="col-lg-6">
                <label class="form-label">اسم ممثل المؤسسة</label>
                    <input 
                    type="text" 
                    class="form-control" 
                    value={repName} 
                    onChange={(e) => setRepName(e.target.value)}
                    placeholder="الاسم"
                    />
                    </div>

                

               
                {/* <!-- Full name --> */}
                <div class="col-lg-6">
                <label class="form-label">رقم هوية ممثل المؤسسة</label>
                    <input 
                    type="number" 
                    class="form-control" 
                    value={idNumber} 
                    onChange={idNumberHandler}
                    placeholder="رقم الهوية"
                    />
                    </div>

                

                {/* <!-- Number --> */}
                <div class="col-lg-6">
                  <label class="form-label">رقم الجوال </label>
                  <div className='dr-ltr'>
                    <PhoneInput
                      defaultCountry="QA"
                      placeholder="رقم الجوال ..."
                      value={phoneNumber}
                      onChange={phoneNumberHandler}
                      />
                      </div>
                </div>

                


                {/* <!-- Add Attachments --> */}
            <div className='my-5'>
                <div class="d-sm-flex justify-content-sm-between align-items-center">
                  <div>
                    <h5 class="mb-2 mb-sm-0">التزكيات والمرفقات</h5>
                   <span className='small'>أي مرفقات وتزكيات</span>
                  </div>
                  <div>
                  {isLoading ? 
                    <button class="btn btn-success" type="button" disabled>
                      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      يتم التحميل...
                    </button> :
                      <button type='button' onClick={handleShowAttachModal} class="btn btn-sm btn-success-soft mb-0"><i class="bi bi-plus-circle me-2"></i>إضافة</button>}
                  </div>
                </div>
                <div className='mt-3'>
                 {attachments.map((at,i)=>(
                  <div key={i} className='d-flex align-items-center mb-2'>
                  <i class="bi bi-book fa-fw me-2"></i>
                  <p className='mb-0'>{at.title}</p>
                </div>
                 ))} 
                 
                </div>
              </div>

                


                


                {/* <!-- Save button --> */}
                
                <div class="d-flex justify-content-end mt-4">
                    {isLoading ?
                    <button class="btn btn-primary" type="button" disabled>
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        يتم التحميل...
                    </button> 
                    :
                    <button onClick={handleSubmit} class="btn btn-primary mb-0">تأكيد</button>
                    }
                </div>



                

                <div class='row'>
                
                
                </div>


            </form>
          }
          </div>
          {/* <!-- Card body END --> */}
        </div>
	  </div>
    </>
  )
}

export default OrganizationVerifyAccount